// Google Analytics 4 lightweight loader.
// Consent Mode V2: defaults are sent BEFORE gtag loads (set by initConsentDefaults).
// The gtag script itself loads regardless — Google Consent Mode handles pings cookielessly when denied.
import i18n from "../i18n";
import { trackPixel } from "./metaPixel";

let loaded = false;

// Map our GA4 event names → Meta Pixel standard events (auto-bridge).
const META_EVENT_MAP = {
  generate_lead: "Lead",
  click_whatsapp: "Contact",
};

const HREFLANG_MAP = { pt: "pt-PT", en: "en", de: "de", fr: "fr", es: "es", nl: "nl", it: "it", zh: "zh-CN" };

function currentSlug() {
  try {
    const p = window.location.pathname.replace(/^\/+|\/+$/g, "");
    return p || "home";
  } catch { return "home"; }
}

function currentLanguage() {
  try {
    const lng = (i18n && i18n.language) ? i18n.language.split("-")[0] : "pt";
    return HREFLANG_MAP[lng] || lng;
  } catch { return "pt-PT"; }
}

export function initGA() {
  if (loaded) return;
  const id = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!id || id === "G-XXXXXXXXXX") return;
  loaded = true;
  // dataLayer & gtag function must be available before the script tag loads
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  // (consent default was already pushed by initConsentDefaults BEFORE this runs)
  gtag("js", new Date());
  gtag("config", id, { anonymize_ip: true });

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
}

export function trackEvent(name, params = {}) {
  if (typeof window.gtag !== "function") return;
  const lang = params.language || currentLanguage();
  const slug = params.slug || currentSlug();
  // GA4 silently dedupes `language` against the auto-collected `ul` user-language.
  // We also send `lang` (non-reserved) to guarantee delivery as a Custom Dimension.
  const enriched = {
    ...params,
    slug,
    language: lang,
    lang,
  };
  window.gtag("event", name, enriched);
  // Bridge to Meta Pixel for standard events (Lead, Contact).
  const metaEvent = META_EVENT_MAP[name];
  if (metaEvent) {
    const pixelParams = {};
    if (params.service) pixelParams.content_name = params.service;
    if (params.source) pixelParams.content_category = params.source;
    trackPixel(metaEvent, pixelParams);
  }
  // Debug bridge: any listener (e.g. DebugOverlay) can subscribe without coupling.
  try {
    window.dispatchEvent(new CustomEvent("icb:ga4", { detail: { name, params: enriched, ts: Date.now() } }));
  } catch { /* noop */ }
}
